// TSS vite/03 §"Query keys convention". Tuples, entity name first.
//
// `events` for the feed and `tasks` for the counts, because that is the
// resource each one reads. A vocabulary of its own — `['live', …]` — would
// make an invalidation from the task screens miss these, and the counts on
// this screen would keep showing a queue that another tab already drained.

export const liveKeys = {
    all:    ['events'],
    feed:   (params) => ['events', 'feed', params],
    // One event, for what its notice does not carry: the author.
    event:  (id) => ['events', 'detail', id],
    // The prefix, for invalidating every state at once.
    counts: ['tasks', 'count'],
    count:  (params) => ['tasks', 'count', params],
    // The prefix, for asking again whenever a notice moves a reservation.
    holds:  ['tasks', 'held'],
    // The tasks somebody is holding right now, which is how an agent is known
    // to be working: a reservation is the only thing in the system that says
    // "this credential is on this, now".
    held:   (params) => ['tasks', 'held', params],
};
